import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useAuth } from '../../../context/auth'
import { isUserExistsInGroup } from '../../../utils/userRights.ts'

interface RequireAuthProps {
  children: ReactNode
}

const RequireAuth = ({ children }: RequireAuthProps) => {
  const { state, dispatch } = useAuth()
  const location = useLocation()

  const handleUnauthorizedUser = () => {
    toast.error('Brak uprawnień do panelu administracyjnego.')
    dispatch({ type: 'LOGOUT' })
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  const hasValidPanelAccess = () => {
    const hasEmptyGroups = state.groups?.length === 0
    const hasUserRights = isUserExistsInGroup(state.groups, 'dd_panel_users')
    const hasRestrictedUserRights = isUserExistsInGroup(state.groups, 'dd_panel_restricted_users')

    return !hasEmptyGroups && (hasUserRights || hasRestrictedUserRights)
  }

  if (!state.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!hasValidPanelAccess()) {
    return handleUnauthorizedUser()
  }


  return <>{children}</>
}

export default RequireAuth
